module.exports = __webpack_public_path__ + "static/media/seafood-with-tofu-soup.b8a9a707.jpg";